import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { SuccessIcon } from '../../icons/SuccessIcon.js';
import styles from './Confirmation.module.scss.js';

var Confirmation = function (_a) {
    var title = _a.title, description = _a.description, children = _a.children, icon = _a.icon, className = _a.className, style = _a.style;
    return (jsxs("div", __assign({ className: clsx(styles.confirmation, className), style: style }, { children: [icon ? icon : jsx(SuccessIcon, { size: "l", className: styles.icon }), jsx("h1", __assign({ className: styles.title }, { children: title })), jsx("p", __assign({ className: styles.description }, { children: description })), children] })));
};
Confirmation.Divider = function (_a) {
    var className = _a.className, style = _a.style;
    return (jsx("hr", { className: clsx(className, styles.divider), style: style }));
};
Confirmation.Row = function (_a) {
    var name = _a.name, children = _a.children, className = _a.className;
    return (jsxs("div", __assign({ className: clsx(styles.row, className) }, { children: [jsx("span", { children: name }), children] })));
};

export { Confirmation };
